<template>
  <div class="chart-table">
    <div v-if="title" class="m-title">{{ title }}</div>
    <div class="board-box core" v-loading="loading">
      <div class="layui-form layui-card-header layuiadmin-card-header-auto">
        <div class="layui-inline">
          <input type="text" autocomplete="off" class="layui-input" placeholder="请输入查询条件"
            v-model="tableObj.queryObject['WORK_ORDER_NUM:2,BRAND_NAME:2,STORE_NAME:2,MANAGER_NAME:2']"/>
        </div>
        <button class="layui-btn layuiadmin-btn-list" @click="$refs.tId.search()" title="查询">查询</button>
        <div style="float: right;">
            <button class="layui-btn refresh" title="刷新列表" @click="$refs.tId.reset();">
              <i class="layui-icon">&#xe669;</i>
              刷 新
            </button>
        </div>
      </div>
      <layui-table
        v-if="tabConfig.serName"
        :ref="tId"
        :request-unique-id="tabConfig.requestUniqueId"
        :table-name="tabConfig.serName"
        :defaultCondition="tabConfig.condition"
        :page-size="20"
        :page-range="6"
        :page-options="[10, 20, 50, 100]"
        :skin="'line'"
        :height="height"
        :before-load="() => loading = true"
        :after-load="() => loading = false"
        @table-event-detail="detail($event.data)"
      >
        <div>
          <div align="center" title="序号" width="60" fixed="left">
            <script type="text/html" v-pre>
              <div class="layui-btn-xs" style="cursor:pointer; display: inline-block; width: 100%;">{{ d.LAY_INDEX }}</div>
            </script>
          </div>
          <layui-tableconfig :config="tabConfig.cols"></layui-tableconfig>
          <div align="center" fixed="right" title="操作" width="60">
            <script type="text/html" v-pre>
              <a class=" layui-btn-xs" lay-event="detail" >查看</a>
            </script>
          </div>
        </div>
      </layui-table>
    </div>
  </div>
</template>

<script>
import comTable from './mixins/comTable'
/**
 * 表格
 */
export default {
  mixins: [comTable],
  name: 'ChartTable1',
  props: {
    height: { type: String, default: '260' }
  },
  components:{
  },
  data() {
    return {
      tabConfig: {
        requestUniqueId: 'keFu_table_1_jinRi',
        /** 数据库表名 */
        serName: 'YW_WORK_ORDER_DETAIL_V1',
        /**
         * 订单类型
         * - 服务单（现场服务请求）-service
         * - 工单（服务请求）-work
         */
        tableType: 'work',
        /** 查询条件 P2参数 */
        condition: {
          // 今日工单
          // WHERE YW_WORK_ORDER_CREATE_TIME LIKE "%2021-07-15%"
          'YW_WORK_ORDER_CREATE_TIME:2': formatDate(Date.now(), 'yyyy-MM-dd')
        },
        /** Table 列配置 */
        cols: [
          // { title: '序号', field: 'index', width: 80 },
          { title: '工单状态', field: 'ORDER_STATE_DESC', width: 130 },
          { title: '服务请求单编号', field: 'WORK_ORDER_NUM', width: 130 },
          {
            title: '工单类型',
            field: 'WORK_ORDER_CATEGORY_DESC',
            width: 100,
            translateDomain: 'TRNSLATE_WORK_ORDER_CATEGORY'
          },
          { title: '描述', field: 'SERVICE_DESCRIPTION', width: 200},
          { title: 'SLA 等级', field: 'SLA_LEVEL', width: 130 },
          { title: '服务方式', field: 'WORK_ORDER_METHOD_DESC', width: 130 },
          { title: '项目经理', field: 'MANAGER_NAME', width: 130 },
          { title: '客户', field: 'CLIENT_NAME', width: 200 },
          { title: '品牌', field: 'BRAND_NAME', width: 200 },
          { title: '门店', field: 'STORE_NAME' , width: 200},
          { title: '服务商', field: 'SERVICE_NAME', width: 200 },
          { title: '创建时间', field: 'YW_WORK_ORDER_CREATE_TIME', width: 160 },
        ]
      },
      tableObj: {
        checkedRows: 0,
        queryObject: {}
      },
    }
  },
  mounted() {
    this.tableObj = this.$refs.tId;
  },
  methods: {}
}
</script>
<style scoped>
  .layui-inline >>> .layui-icon-date{
    top: -2px !important;
  }
  .layui-card-header.layuiadmin-card-header-auto {
    padding-top: 4px;
    padding-bottom: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/viewBoard/components/ChartTable1.vue